export default __webpack_public_path__ + "static/media/mcbg.54012556.jpg";